import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Button,
    Box
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';

import requestNotionService from '../../../domain/services/request/notion/request.notion.service';
import stepsSolicitation from '../../../domain/constant/steps.solicitation.constant';
import LoadingProgress from '../../LoadingProgress';
import { requestServices } from '../../../domain/constant/request.services.constant';

const PetitionIndicationAccordion = ({ request }) => {
    const history = useHistory();
    const [petitionIndications, setPetitionIndications] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        load(true);
    }, []);

    const load = (showAlert) =>
        findPetitionIndications(request.id, showAlert);

    const findPetitionIndications = async (requestId, showAlert) => {
        setLoading(true);

        const values = await requestNotionService
            .findPetitionIndications(requestId)
            .catch(() => ([]))
            .finally(() => setLoading(false));

        const newPetitions = values.filter(p => p.status === stepsSolicitation.NEW);
        setPetitionIndications(newPetitions);
    };

    const redirectToPetitionDetail = (petitionIndication) => {
        history.push(`/solicitations/${request.id}/petition-indication/${petitionIndication.id}`);
    };

    const handleAccordionChange = (event, isExpanded) => {
        setExpanded(isExpanded);
    };

    if (request.status != stepsSolicitation.CONCLUDED || (!isLoading && (!petitionIndications || petitionIndications.length === 0))) {
        return null;
    }

    return (
        <div className='mb-4' >
            {isLoading && <LoadingProgress transparentBackground={true} />}

            {!isLoading && petitionIndications.length > 0 && (
                <Accordion
                    expanded={expanded}
                    onChange={handleAccordionChange}
                    className="!rounded-lg !border !border-[#ffdf20] overflow-hidden before:!hidden"
                    style={{ margin: expanded ? '0 0 16px 0' : undefined }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon className='text-yellow-700' />}
                        className="!bg-[#fefdf3] !rounded-lg"
                        style={{
                            borderBottom: expanded ? '1px solid #ffdf20' : 'none',
                            borderRadius: expanded ? 'unset !important' : '8px',
                        }}
                        classes={{
                            content: 'flex items-center !my-3',
                        }}
                    >
                        <Box className="ml-2 mr-5 bg-[#f0b100] rounded-full flex items-center justify-center w-10 h-10 flex-shrink-0">
                            <WarningRoundedIcon className="text-white" style={{ fontSize: 22 }} />
                        </Box>
                        <Box>
                            <Typography className='!text-lg !font-medium' variant="subtitle1">
                                {petitionIndications.length === 1 ? 'Você tem sugestão de petição' : 'Você tem sugestões de petição'}
                            </Typography>
                            <Typography className='!text-sm !text-gray-500' variant="caption" color="textSecondary">
                                {`${petitionIndications.length} ${petitionIndications.length === 1 ? 'petição disponível' : 'petições disponíveis'} para o seu caso`}
                            </Typography>
                        </Box>
                    </AccordionSummary>

                    <AccordionDetails className='flex flex-col !p-8'>
                        <Typography className='bg-yellow-50 p-4 rounded-lg !mb-4' variant="body2" color="textPrimary" paragraph>
                            Para prosseguir com a elaboração da minuta, pressione "Solicitar Serviço". Observe: 1 crédito será descontado do seu pacote por petição solicitada.
                        </Typography>

                        {petitionIndications.map((petitionIndication, index) => (
                            <Box
                                key={index}
                                className={`flex flex-col p-4 border border-[#ededed] rounded-lg ${index === petitionIndications.length - 1 ? 'mb-0' : 'mb-4'} md:flex-row md:items-center md:justify-between`}
                            >
                                <Box className="flex-1 mb-2 md:mb-0 md:mr-4">
                                    <div className="flex items-center gap-2">
                                        <DescriptionOutlinedIcon className="h-5 w-5 text-yellow-600" />
                                        <Typography className="!text-base !font-medium !text-foreground" variant="body1">
                                            {petitionIndication.serviceName} - {petitionIndication.areaName}
                                            {petitionIndication.serviceKey !== requestServices.PETITION &&
                                                ` - ${petitionIndication.modalityName}`
                                            }
                                        </Typography>
                                    </div>
                                </Box>

                                <Box className="flex flex-col gap-2 sm:flex-row sm:items-center">
                                    <Button
                                        className='!rounded-lg !text-sm md:!text-base h-10 !font-normal'
                                        color="primary"
                                        variant="contained"
                                        size="small"
                                        onClick={() => redirectToPetitionDetail(petitionIndication)}
                                    >
                                        Solicitar Serviço
                                    </Button>
                                </Box>
                            </Box>
                        ))}
                    </AccordionDetails>
                </Accordion>
            )}
        </div>
    );
};

export default PetitionIndicationAccordion;
